import _get from "lodash/get";

import Button from "@components/Button";
import SellerReviewsStarRating from "@components/Seller/SellerReviews/SellerReviewsStarRating";

const SellerReviewsInfo = ({ reviewsSummary, userCanPostReview }) => {
  const reviewsCount = _get(reviewsSummary, "items[0].reviews.value", 0);
  const reviewsRating = _get(reviewsSummary, "items[0].reviews.total", 0);

  return (
    <div className="md:flex items-start mt-4 mb-10">
      <div className="min-w-[200px] text-center">
        {reviewsSummary && (
          <>
            <h4 className="my-0 text-4xl lg:text-40px text-black font-medium">
              {isNaN(reviewsRating / reviewsCount)
                ? 0
                : Math.round(
                    (reviewsRating / reviewsCount + Number.EPSILON) * 100
                  ) / 100}
              <span className="text-gray-light"> din 5</span>
            </h4>

            <div className="mb-4 md:mb-8">
              <SellerReviewsStarRating
                reviewsCount={reviewsCount}
                reviewsRating={reviewsRating}
              />
            </div>
          </>
        )}

        <div className="hidden md:block">
          <Button
            title="Adauga recenzia ta"
            display="block"
            size="normal"
            onClick={() => userCanPostReview()}
          />
        </div>
      </div>
    </div>
  );
};

export default SellerReviewsInfo;
